import { TypeOfWork } from '@pflegia/types/api/candidate/type-of-work';
import { SeoPageType } from '@pflegia/types/common/seo-page-meta/seo-page-meta';

export const getJobsSeoPageType = ({
  hasJobTitle,
  hasLocation,
  typeOfWork,
}: {
  hasJobTitle: boolean;
  hasLocation: boolean;
  typeOfWork?: TypeOfWork;
}): SeoPageType | null => {
  if (typeOfWork) return null;
  if (hasJobTitle && hasLocation) return SeoPageType.JobsRoleCity;
  if (hasJobTitle) return SeoPageType.JobsRole;
  if (hasLocation) return SeoPageType.JobsCity;
  return null;
};
